import { useEffect } from 'react';
import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import SelectCompany from 'src/components/SelectCompany';
import useCompany from 'src/hooks/useCompany';
import useGuideMe from 'src/hooks/useGuideMe';
import useViewCalendarYear from 'src/hooks/useViewCalendarYear';
import { useGuideMeSteps } from './GuideMeSteps';

const ViewPeriodsNavBar = () => {
  const { company } = useCompany();
  const { guideMe } = useGuideMe({
    steps: useGuideMeSteps(),
    guideId: 'view-periods-guide-me',
  });
  const { pageTitle, setIsPeriodEditMode } = useViewCalendarYear();

  useEffect(() => {
    if (company?.companyId) {
      setIsPeriodEditMode(false);
    }
  }, [company?.companyId, setIsPeriodEditMode]);
  return (
    <>
      <Navbar title={pageTitle} />
      <Layout>
        <div className="flex justify-center items-center flex-wrap min-h-[56px]">
          <SelectCompany />
          <div className="flex-grow">&nbsp;</div>
          {company.companyId && guideMe}
        </div>
      </Layout>
    </>
  );
};
export default ViewPeriodsNavBar;
